var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-menu_Community_MVP-3",
    transform: "translate(-332.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(5.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-2",
    transform: "translate(71.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Categoty-title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Add",
    transform: "translate(252.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#10CCC6",
    fillRule: "nonzero",
    points: "15.8333333 10.8333333 10.8333333 10.8333333 10.8333333 15.8333333 9.16666667 15.8333333 9.16666667 10.8333333 4.16666667 10.8333333 4.16666667 9.16666667 9.16666667 9.16666667 9.16666667 4.16666667 10.8333333 4.16666667 10.8333333 9.16666667 15.8333333 9.16666667"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e54ff7d8.svg";
export { ForwardRef as ReactComponent };